import i18n from '../strings/i18n';
import useCurrentLanguage from './use-current-language';
const useTranslation = () => {
    const currentLanguage = useCurrentLanguage();
    return i18n(currentLanguage);
};
export default useTranslation;
//# sourceMappingURL=use-translation.js.map